import React, {Component} from 'react';
import { Modal, Form, Button } from 'react-bootstrap';

export default class Domain extends Component {
    render() {
        return (
            <Modal show={this.props.showModal} onHide={this.props.hideModal}>
                <Modal.Header closeButton>
                      <Modal.Title id="example-custom-modal-styling-title">
                         <h5>Add Domain</h5>
                         <p>Add your landing url domain</p>
                     </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Form.Label>Domain</Form.Label>
                        <Form.Control type="text" placeholder="Enter Domain" value={this.props.domain} onChange={this.props.handleDomain}/>
                        <p className='sub_muted'> Enter Domain Without <span className="text-primary">http://</span> or <span className="text-primary">https://</span>  </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn closeBtn' onClick={this.props.hideModal}>Close</Button>
                    <Button className='btn btn-success' onClick={this.props.handleCreate}>Create</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}